module.exports = __webpack_public_path__ + "static/media/parking-slash.ecc19702.svg";